"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NblocksPublicClient = void 0;
const axios_1 = require("axios");
const UnauthenticatedError_1 = require("../errors/UnauthenticatedError");
const ForbiddenError_1 = require("../errors/ForbiddenError");
const ClientError_1 = require("../errors/ClientError");
const NotFoundError_1 = require("../errors/NotFoundError");
const oauth_1 = require("./auth/oauth");
const specific_entity_1 = require("../abstracts/specific-entity");
const portal_1 = require("./portal/portal");
const flag_1 = require("./flag/flag");
/**
 * This is the Public Nblocks client.
 * This exposes all Nblocks features that can be used in a public context. You only idenfy with app id.
 */
class NblocksPublicClient extends specific_entity_1.SpecificEntity {
    constructor(args) {
        super(args.appId, null, args.debug);
        this.version = args.version || 1;
        this.stage = args.stage || 'PROD';
        this.httpClient = axios_1.default.create({});
        this.configureHttpClient(this.httpClient);
        this.auth = new oauth_1.OAuth(this, this.debug);
        this.portal = new portal_1.Portal(this, this.debug);
        this.flag = new flag_1.Flag(this, this.debug);
        this._log(`Initialized NblocksPublicClient in stage ${this.stage}, app id: ${this.id}`);
    }
    /** **Internal functionality. Do not use this function** */
    getPlatformClient() {
        return this;
    }
    /** **Internal functionality. Do not use this function** */
    getHttpClient() {
        return this.httpClient;
    }
    configureHttpClient(httpClient) {
        const debug = this.debug;
        if (debug) {
            httpClient.interceptors.request.use(request => {
                console.log(`${request.method.toUpperCase()} ${request.baseURL}/${request.url}`, "Headers", request.headers);
                console.log("Body:", request.data);
                return request;
            });
        }
        httpClient.interceptors.response.use(function (response) {
            if (debug) {
                console.log("Response:", response.status, response.data);
            }
            return response;
        }, function (error) {
            if (debug) {
                console.log("Error response:", `Http status: ${error.response.status}`, error.response.data);
            }
            if (!error.response)
                return Promise.reject(error);
            let customError;
            switch (error.response.status) {
                case 401:
                    customError = new UnauthenticatedError_1.UnauthenticatedError(error.response.data);
                    break;
                case 403:
                    customError = new ForbiddenError_1.ForbiddenError(error.response.data);
                    break;
                case 404:
                    customError = new NotFoundError_1.NotFoundError(error.response.data);
                    break;
                default:
                    customError = new ClientError_1.ClientError(error.response.data);
                    break;
            }
            return Promise.reject(customError);
        });
    }
}
exports.NblocksPublicClient = NblocksPublicClient;
